var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "working-hours" }, [
    _vm.workingHours
      ? _c(
          "ul",
          { staticClass: "working-hours-list" },
          _vm._l(_vm.workingHours, function (workingHour, index) {
            return workingHour
              ? _c("li", { key: index, staticClass: "row" }, [
                  _c("div", { staticClass: "small-4 medium-4 large-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("workDayOptions." + workingHour.workingDayFrom)
                        ) +
                        " " +
                        _vm._s(
                          workingHour.workingDayTo &&
                            workingHour.workingDayTo !==
                              workingHour.workingDayFrom
                            ? "- " +
                                _vm.$t(
                                  "workDayOptions." + workingHour.workingDayTo
                                )
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small-7 medium-7 large-7" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.customWorkingHourLabel(
                            workingHour.workingHourFrom
                          )
                        ) +
                        " " +
                        _vm._s(
                          workingHour.workingHourTo &&
                            workingHour.workingHourTo !==
                              workingHour.workingHourFrom
                            ? "- " + workingHour.workingHourTo
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disabled,
                        expression: "!disabled",
                      },
                    ],
                    staticClass: "fa fa-times fa-lg",
                    class: "delete-working-hour-" + index,
                    attrs: { "aria-hidden": true },
                    on: {
                      click: function ($event) {
                        return _vm.deleteWorkingHour(index)
                      },
                    },
                  }),
                ])
              : _vm._e()
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showWorkingHours && !_vm.disabled ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.disabled,
            expression: "!disabled",
          },
        ],
        staticClass: "working-hours-add",
      },
      [
        _c("HKLSelect", {
          staticClass: "workingDayFrom",
          class: {
            "error-highlight":
              _vm.invalidWorkingHour ||
              (_vm.isMandatory && _vm.emptyWorkingHours),
          },
          attrs: {
            name: "workingDayFrom",
            value: _vm.workingDayFrom || undefined,
            options: _vm.workingDayFromHklOptions,
            showSearch: true,
            placeholder: "",
          },
          on: {
            change: function ($event) {
              _vm.workingDayFrom = $event || ""
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "dash" }),
        _vm._v(" "),
        _c("HKLSelect", {
          staticClass: "workingDayTo",
          class: {
            "error-highlight":
              _vm.invalidWorkingHour ||
              (_vm.isMandatory && _vm.emptyWorkingHours),
          },
          attrs: {
            name: "workingDayTo",
            disabled: _vm.workingDayFrom === "PH",
            value: _vm.workingDayTo || undefined,
            options: _vm.workingDayToHklOptions,
            showSearch: true,
            placeholder: "",
          },
          on: {
            change: function ($event) {
              _vm.workingDayTo = $event || ""
            },
          },
        }),
        _vm._v(" "),
        _c("HKLSelect", {
          staticClass: "workingHourFrom",
          class: {
            "error-highlight":
              _vm.invalidWorkingHour ||
              (_vm.isMandatory && _vm.emptyWorkingHours),
          },
          attrs: {
            name: "workingHourFrom",
            value: _vm.workingHourFrom || undefined,
            options: _vm.workingHourFromHklOptions,
            showSearch: true,
            placeholder: "",
          },
          on: {
            change: function ($event) {
              _vm.workingHourFrom = $event || ""
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "dash" }),
        _vm._v(" "),
        _c("HKLSelect", {
          staticClass: "workingHourTo",
          class: {
            "error-highlight":
              _vm.invalidWorkingHour ||
              (_vm.isMandatory && _vm.emptyWorkingHours),
          },
          attrs: {
            name: "workingHourTo",
            disabled: _vm.workingHourFrom === "Anytime",
            value: _vm.workingHourTo || undefined,
            options: _vm.workingHourToHklOptions,
            showSearch: true,
            placeholder: "",
          },
          on: {
            change: function ($event) {
              _vm.workingHourTo = $event || ""
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue btn-add add-working-hour",
            attrs: {
              id: "modules-tenders-workingHours-add",
              disabled: _vm.disableButton(),
              type: "button",
              role: "add-button",
              name: "add-working-hour",
            },
            on: { click: _vm.addWorkingHour },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("action.add")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }